import React, { useEffect, useState } from "react";

import { fetchFinishEducation } from "../../actions/education";
import { useDispatch } from "react-redux";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import { useNavigate } from "react-router-dom";
import EducationCustomModal from "../../pages/Education/EducationCustomModal";
import ConfirmDialog from "./ConfirmDialog";
import { useTranslation } from "react-i18next";

const convertTimeToSeconds = (timeString) => {
  if (!timeString) return 0; // Ako nema vremena, vrati 0
  const timeParts = timeString?.split(":"); // Razdvaja string na delove (sati, minuti, sekunde)
  const hours = parseInt(timeParts[0], 10); // Pretvara sate u broj
  const minutes = parseInt(timeParts[1], 10); // Pretvara minute u broj
  const seconds = parseInt(timeParts[2], 10); // Pretvara sekunde u broj

  // Vraća ukupno vreme u sekundama
  return hours * 3600 + minutes * 60 + seconds;
};

const EducationCounter = (props) => {
  const { educationDetail, educationItemsList } = props || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [showModal, setShowModal] = useState(false);
  const [showModalCancel, setShowModalCancel] = useState(false);
  const [modalTitle, setModalTitle] = useState("");

  // Provera i preusmeravanje ako nema educationDetail
  useEffect(() => {
    if (!educationDetail) {
      navigate("/education-list");
    }
  }, [educationDetail, navigate]);

  const durationFull = educationDetail?.duration;

  const duration = convertTimeToSeconds(durationFull);

  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    // Ako vreme nije postavljeno, ništa se ne radi
    if (!duration) return;

    // Postavljanje intervala koji se pokreće svakih 1000 ms (1 sekunda)
    const interval = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(interval); // Zaustavljamo odbrojavanje kada vreme dostigne 0

          const items = {
            educationAttemptId: educationItemsList.attemptId, // Koristi attemptId
            status: "expired",
          };
          dispatch(fetchFinishEducation(items, navigate));
          setShowModal(true);
          setModalTitle(
            t("education.cancel_test.time_expired_title") // Prevedeni tekst
          );
          return 0;
        }
        return prevTime - 1; // Smanjujemo vreme za 1 sekundu
      });
    }, 1000);

    // Čišćenje intervala kada se komponenta unmount-uje
    return () => clearInterval(interval);
  }, [dispatch, duration, navigate, educationItemsList.attemptId]);

  // Formatiranje vremena (npr. 1200 sekundi -> 20:00)
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const handleCancelTest = () => {
    setShowModalCancel(true);
  };

  const handleConfirmExit = () => {
    setShowModalCancel(false);
    const items = {
      educationAttemptId: educationItemsList.attemptId,
      status: "abandoned",
    };
    dispatch(fetchFinishEducation(items, navigate));
    setShowModal(true);
    setModalTitle(t("education.cancel_test.abandoned_title")); // Prevedeni tekst
  };

  return (
    <div className="education-counter-content">
      <div className="close-education-button" onClick={handleCancelTest}>
        <HighlightOffOutlinedIcon /> {t("education.cancel_test.cancel_button")}
      </div>
      <h3>{formatTime(timeLeft)}</h3>
      <EducationCustomModal
        showModal={showModal}
        messageType={"error"}
        modalTitle={modalTitle}
      />
      <ConfirmDialog
        showModal={showModalCancel}
        setShowModal={setShowModalCancel}
        confirmLogout={handleConfirmExit}
        modalTitle={t("education.cancel_test.confirm_exit")}
      />
    </div>
  );
};

export default EducationCounter;
